import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    wrapper: {
        borderBottom: `1px solid ${theme.colors.grey_light}`,
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        padding: `${theme.spacing(1)}px 0`,
        flexWrap: 'wrap',
    },
    header: {
        flex: '1 1 auto',
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2.5),
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
        marginLeft: -theme.spacing(2),
        borderRadius: theme.radius,
        transition: 'background-color 0.2s ease',
    },
    clickable: {
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.colors.icon_background,
        },
    },
    headerExpanded: {
        backgroundColor: color(theme.colors.violet_primary).fade(0.86).string(),
        '&:hover': {
            backgroundColor: color(theme.colors.violet_primary).fade(0.8).string(),
        },
    },
    version: {
        fontFamily: theme.font.secondary,
        fontSize: 18,
        lineHeight: 1.3,
        letterSpacing: '0.01em',
        color: theme.colors.black,
        whiteSpace: 'nowrap',
    },
    date: {
        fontSize: 14,
        fontFamily: theme.font.primary,
        color: theme.colors.grey_text,
        whiteSpace: 'nowrap',
    },
    spacer: {
        flex: '1 1 auto',
    },
    chevron: {
        color: theme.colors.grey_text,
        flexShrink: 0,
    },
    chevronExpanded: {
        color: theme.colors.violet_primary,
    },
    downloadBtn: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        flexShrink: 0,
        border: '1px solid transparent',
        cursor: 'pointer',
        fontFamily: theme.font.secondary,
        fontSize: 14,
        lineHeight: 1.4,
        color: theme.colors.violet_primary,
        backgroundColor: theme.colors.transp_violet,
        borderRadius: theme.radius,
        padding: `0 ${theme.spacing(3)}px`,
        minHeight: 40,
        transition: '0.2s ease',

        '&:hover': {
            backgroundColor: theme.colors.violet_primary,
            color: theme.colors.white,
            boxShadow: `0 2px 8px 0 ${color(theme.colors.violet_primary).fade(0.55).string()}`,
        },

        '&:active': {
            backgroundColor: theme.colors.violet_darker,
            color: theme.colors.white,
        },

        '&:disabled': {
            color: theme.colors.grey_text,
            backgroundColor: color(theme.colors.transp_violet).fade(0.84).string(),
            cursor: 'default',
            boxShadow: 'none',
        },
    },
    downloadIcon: {
        fontSize: 18,
    },
    notes: {
        padding: `0 0 ${theme.spacing(3)}px`,
    },
    markdown: {
        color: theme.colors.black,
        fontFamily: theme.font.primary,
        fontSize: 14,
        lineHeight: 1.5,
        '& *': {
            font: 'revert',
            fontFamily: 'inherit',
            listStyle: 'revert',
            listStylePosition: 'inside',
        },
    },
}));
